import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import PurohitMap from '../components/PurohitMap';
import { authToken } from '../globals/Global';

export default function PurohitMapPage() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Purohit Locations Map
      </Typography>

      <Paper elevation={3} sx={{ height: '80vh', overflow: 'hidden' }}>
        <PurohitMap 
          bearerToken={authToken || localStorage.getItem('sessionToken')}
          onError={(err) => console.error('Map error:', err)}
        />
      </Paper>
    </Box>
  );
}
